import { IConfigControlGridDefaultGroups, IGridDefaultGroupsControl } from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';
import { CpControl } from './cp-control';

export class CpGridDefaultGroupsControl extends CpControl {
    readonly controlTypeGroup = 'GridDefaultGroups';
    readonly dataBinding: DataBinding;
    idGroupList: string;
    idGroupItemList: string;
    icon: string;
    iconTooltip: string;
    config: IConfigControlGridDefaultGroups;

    constructor(control: IGridDefaultGroupsControl, dataBindingContext?: DataBinding) {
        super(control);
        this.config = control.config[0];
        this.dataBinding = new DataBinding(this.config.dataBinding, dataBindingContext);
        this.initConfigParams();   
    }

    canAlignToBottom() {
        return false;
    }

    getHeightHint() {
        return 51;
    }

    private initConfigParams() {
        this.idGroupList = this.config.idGroupList;
        this.idGroupItemList = this.config.idGroupItemList;
        this.icon = this.config.icon;
        this.iconTooltip = this.config.tooltip;
    }

}
